export default "__VITE_ASSET__DfmMmNVL__"